import { useEffect, useMemo, useState } from 'react';
import { getAssignmentStatusListByStudent } from '../../../../api/utils/lms/assignment/api';
import { AssignmentStatusByStudentItem } from '../../../../constants/types/lms/assignment/type';
import { useAppDispatch, useAppSelector } from '../../../../store/hook';
import { openAlert } from '../../../../store/features/modalSlice';
import { getErrorMessages } from '../../../../api/utils/util-func';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../Loading/LoadingSpinner';
import StudentListContents from './StudentListContents';
import StatusByStudentContents from './StatusByStudentContents';
import { selectLmsLists } from '../../../../store/features/lmsSlice';
import { AssignmentType, CourseId } from '../../../../constants/types/lms/type';

/**
 * 개편 LMS (교사) - 과제 관리 > 과제 현황 페이지 > 학생 선택 판넬
 */
const AssignmentStudentPanel = () => {
  const { classId } = useParams();

  const lmsLists = useAppSelector(selectLmsLists);

  const courseType = useMemo(() => {
    switch (lmsLists.course.id) {
      case CourseId.BASIC:
        return 'BASIC';
      case CourseId.WMW:
        return 'WMW';
      case CourseId.HFHJ:
        return 'HFHJ';
      default:
        return null;
    }
  }, [lmsLists]);

  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [studentList, setStudentList] = useState<
    AssignmentStatusByStudentItem[]
  >([]);

  useEffect(() => {
    if (!classId) return;

    const fetchAssignmentStudentList = async () => {
      try {
        setIsLoading(true);

        const response = await getAssignmentStatusListByStudent({
          classId,
          toDoStatus: undefined,
          toDoType:
            courseType === 'BASIC'
              ? AssignmentType.JEBSON
              : AssignmentType.JEBSPL,
        });

        setStudentList(response.result ?? []);
      } catch (error) {
        dispatch(openAlert({ message: getErrorMessages(error) }));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignmentStudentList();
  }, [classId, dispatch]);

  const [selectedStudentId, setSelectedStudentId] = useState<number | null>(
    null,
  );

  const selectedStudent = useMemo(() => {
    if (!selectedStudentId) return undefined;

    return studentList.find(
      (studentItem) => studentItem.id === selectedStudentId,
    );
  }, [selectedStudentId]);

  const handleBack = () => {
    setSelectedStudentId(null);
  };

  const handleStudentClick = (classId: number) => {
    setSelectedStudentId(classId);
  };

  if (isLoading) {
    return <LoadingSpinner message="데이터 조회중" />;
  }

  return (
    <>
      {selectedStudent ? (
        <StatusByStudentContents
          selectedStudent={selectedStudent}
          handleBack={handleBack}
        />
      ) : (
        <StudentListContents
          studentList={studentList}
          handleStudentClick={handleStudentClick}
        />
      )}
    </>
  );
};

export default AssignmentStudentPanel;
